import { z } from 'zod'

export const schema = z.object({
  onlineBookingId: z.string(),
})

export type schemaType = z.infer<typeof schema>
